import Menu from "../../../components/Menu"
import RoundyContainer from 'components/RoundyContainer'
import { ReplaceVehicleContextComp } from "components/StraightThroughVehicleComp/ReplaceVehicleContext/ReplaceVehicleContext"
import EndorsementSummaryMain from 'components/StraightThroughVehicleComp/VehicleMain_Add/EndorsementSummaryMain'
import React, { useEffect } from 'react'
import { useNavigate } from "react-router-dom"
import { storageData } from "services/Services"

const ReplaceVehicleEndorsementSummary = (props) => {
    const navigate = useNavigate();
    const { userData } = props.user
    const websiteMaintenance = JSON.parse(storageData?.getItem("websiteMaintenance"));

    useEffect(() => {
        window.scrollTo(0, 0)

        // Redirect to maintenance page if maintenance is on for Add Vehicle Endorsement
        if (websiteMaintenance?.status?.Result == "Active" && websiteMaintenance?.status?.Pages?.includes("EndorsementReplaceVehicle")) {
            navigate("/maintenance")
            return
        }
    }, [])

    return (
        <>
            <ReplaceVehicleContextComp>
                <Menu Title={"REPLACE VEHICLE"} FirstName={userData.firstName} userData={userData} />
                <RoundyContainer Content={EndorsementSummaryMain} NoRoundy
                    params={{
                        storedData: { ...props.storedData },
                        setStoredData: props.setStoredData
                    }}
                />
            </ReplaceVehicleContextComp>
        </>
    )
}

export default ReplaceVehicleEndorsementSummary